import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditCustomFieldPage.css';
import {fetchCustomField, putCustomField} from "../../../store/customfields/actions";
import CustomFieldForm from "../../../components/customfield/CustomFieldForm/CustomFieldForm";
import {SETTING_PAGE} from "../../../constants/routes";

export class EditCustomFieldPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchCustomField();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.customField) {
            this.props.history.push(SETTING_PAGE.replace(':appId', this.props.app.id));
        }
    }

    // Fetch

    fetchCustomField(appId = null, customFieldId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const customField = customFieldId || this.props.match.params.customFieldId;

            if (app && customField) {
                this.props.fetchCustomField(app, customField)
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
       await this.props.putCustomField(this.props.app.id, formProps);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.customField) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Custom field / Edit - {this.props.app.name}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>{this.props.customField.name}</Subheader>

                                <div style={style.paper}>
                                    <CustomFieldForm
                                        initialValues={this.props.initialValues}
                                        entityName={this.props.entityName}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                    />
                                </div>
                                <div style={style.clear}/>
                            </Paper>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    let props = {
        loading: state.apps.pending || state.customFields.pending,
        error: state.apps.error,
        customField: state.customFields.currentCustomField,
        app: state.apps.currentApplication,
        sending: state.customFields.sending
    };

    if (state.customFields.currentCustomField) {
        props.initialValues = state.customFields.currentCustomField;
    }

    return props
}

export default connect(mapStateToProps, {
    putCustomField,
    fetchApp,
    fetchCustomField
})(EditCustomFieldPage);



// WEBPACK FOOTER //
// src/containers/customfield/EditCustomFieldPage/EditCustomFieldPage.js